import { useValidate } from "formvalidation/hooks";
import React, { useEffect } from "react";
import { Input, Message } from "semantic-ui-react";
import { useCustomQuery, useSemanticUiInputRef } from "utilities/hookutils";
import { saveOrCancel } from "utilities/inputUtils";

interface FreeFieldReferenceInputProps {
  validatorKey: string
  mainArea: server.dto.MainAreas
  excludeKey?: number
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
}

export const FreeFieldReferenceInput = (props: FreeFieldReferenceInputProps) => {
  const inputRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.focusOnMount) {
      inputRef.ref.current.focus();
    }
  }, []);

  const freeFieldReferenceValidator = useCustomQuery({
    queryKey: ["freeFieldReferenceValidator", props.value],
    queryFn: () => window.CoreApi.FreeFieldDefinition.ReferenceExists({
      mainArea: props.mainArea,
      excludeId: props.excludeKey,
      reference: props.value
    }).then(r => r.data),
    enabled: false,
  });

  const validateReference = async (): Promise<string | boolean> => {
    if (props.value.length === 0) {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    const referenceExists = await freeFieldReferenceValidator.refetch();
    if (referenceExists.data.data) {
      return RESX.FreeField.ThisReferenceCodeHasAlreadyBeenUsedForAnotherFreeField;
    }

    return true;
  }

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.FreeField.ReferenceCode,
    value: props.value,
    validate: validateReference,
    ref: inputRef.ref,
    type: "manual"
  });

  const onBlur = async () => {
    props.onBlur?.();
  };

  return <>
    <Input
      ref={inputRef.refSetter}
      maxLength={serverReference.constants.freeFieldDefinition.maxReferenceLength}
      fluid
      label={{
        basic: true,
        content: <span>FF</span>
      }}
      labelPosition="left"
      value={props.value}
      onChange={(_, { value }) => { props.onChange(value); }}
      error={validation.error.hasError}
      loading={freeFieldReferenceValidator.isFetching}
      onBlur={onBlur}
      onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    />
    {(validation.error.hasError && validation.error.errorMessage) && <Message color="red">{validation.error.errorMessage}</Message>}
  </>
}